<div class="gpd-config-section">
  <div class="gpd-config-section-header">
    <div>
      <div class="gpd-config-section-title">
        <span i18n="@@taskPackages">Task Packages</span>
      </div>
      <div class="gpd-config-section-description" i18n="@@reasonConfigDescription">
        Define reasons for resetting completed task packages
      </div>
    </div>
    <app-gpd-button text="Add" icon="add" (onClick)="onAdd()" [disabled]="editData"></app-gpd-button>
  </div>
  <div class="section-form" *ngIf="editData">
    <dx-form #form class="gpd-form" [colCount]="2">
      <dxi-item [colSpan]="1" dataField="name">
        <dxo-label i18n-text="@@reason" text="Reason"></dxo-label>
        <dx-text-box class="gpd-input" [(value)]="editData.name"></dx-text-box>
      </dxi-item>
      <dxi-item [colSpan]="2" dataField="buttons">
        <dxo-label [visible]="false"></dxo-label>
        <div class="section-form-buttons gpd-button-group">
          <app-gpd-button text="Cancel" icon="cancel" (onClick)="onCancel()"></app-gpd-button>
          <app-gpd-button text="Save" icon="tick" (onClick)="onSave()"></app-gpd-button>
        </div>
      </dxi-item>
    </dx-form>
  </div>
  <div class="gpd-config-section-content" *ngIf="reasons.length > 0 && !editData">
    <dx-data-grid
      #dgrid
      [dataSource]="reasons || []"
      class="gpd-datagrid"
      width="100%"
      [showBorders]="true"
      [allowColumnResizing]="true"
      [columnAutoWidth]="true"
      [columnHidingEnabled]="true"
      [allowColumnReordering]="true"
    >
      <dxi-column dataField="name" caption="Reason"></dxi-column>
      <dxi-column
        dataField=""
        allowEditing="false"
        cellTemplate="buttonCellTemplate"
        [width]="100"
        [formItem]="{ visible: false }"
      >
        <div *dxTemplate="let item of 'buttonCellTemplate'">
          <div class="gpd-table-actions">
            <app-svg-icon
              icon="edit"
              color="var(--color-primary)"
              [strokeWidth]="1.5"
              [size]="20"
              class="gpd-button-icon"
              (click)="onEdit(item.data)"
            ></app-svg-icon>
            <app-svg-icon
              icon="delete"
              color="var(--color-red-500)"
              [strokeWidth]="1.5"
              [size]="20"
              class="gpd-button-icon"
              (click)="deleteReason(item.data)"
            ></app-svg-icon>
          </div>
        </div>
      </dxi-column>
    </dx-data-grid>
  </div>
</div>
